import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";
import { AuthService } from "services/AuthService";

const isSimplified = AuthService.currentUserValue()
  ? AuthService.getPermissions().includes("skip_order_supervision")
  : false;

const data = {
  initialOrder: {
    destination: "",
    type: "PRE"
  },
  headerOptions: [],
  steps: isSimplified
    ? [
        {
          id: "0",
          name: capitalize(i18n.t("description"))
        },
        {
          id: "1",
          name: capitalize(i18n.t("tags"))
        },
        {
          id: "2",
          name: capitalize(i18n.t("confirmation"))
        }
      ]
    : [
        {
          id: "0",
          name: capitalize(i18n.t("description"))
        },
        {
          id: "1",
          name: capitalize(i18n.t("products"))
        },
        {
          id: "2",
          name: capitalize(i18n.t("tags"))
        },
        {
          id: "3",
          name: capitalize(i18n.t("confirmation"))
        }
      ],
  reasons: [
    {
      label: i18n.t("orders.klasses.SALE"),
      id: "venta"
    },
    {
      label: i18n.t("breaked"),
      id: "rotura"
    },
    {
      label: i18n.t("surplus.merchandise"),
      id: "sobrante"
    },
    {
      label: i18n.t("orders.klasses.ADJ.stock"),
      id: "ajuste"
    },
    {
      label: i18n.t("orders.klasses.AUD"),
      id: "AUD"
    }
  ]
};

export default data;
